import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import { BodyLargeMedium, BodyRegular, BodySmall } from '@src/fonts/typography/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DateSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DateLabel = styled.p`
  ${BodyLargeMedium}
  ${LayoutColors.blackMain}
`;

export const DateValue = styled.p`
  ${BodyRegular}
  ${LayoutColors.blackMain}
`;

export const FeeNote = styled.p`
  ${BodySmall}
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  background: ${LayoutColors.whiteDark};
  color: ${LayoutColors.blackMain};
`;

export const UnavailableTariffLabel = styled.div`
  ${BodyRegular};
  width: 100%;
  padding: 0.25rem;
  box-sizing: border-box;
  background: ${LayoutColors.grayMain};
  border-radius: 0.25rem;
  color: ${LayoutColors.blackMain};
  text-align: center;
`;

export const QuantitySelectorWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;

  border-radius: 0.5rem;
  border: 1px solid ${LayoutColors.grayMain};
  background: ${LayoutColors.whiteLight};
`;
